/**
 * Configuration basée sur le domaine d'accès
 * S'applique uniquement en production
 */

// Fonction pour détecter le domaine actuel
export function getCurrentDomain() {
  return window.location.hostname;
}

// Fonction pour vérifier si on est en production
export function isProduction() {
  return process.env.VUE_APP_ENV === 'production';
}

// Fonction pour vérifier si on est sur le domaine portail (uniquement en production)
export function isPortalDomain() {
  // En développement, toujours false pour utiliser l'interface administrative
  if (!isProduction()) {
    return false;
  }
  
  const domain = getCurrentDomain();
  return domain.includes('prima-benin.org') || domain.includes('localhost') || domain.includes('127.0.0.1');
}

// Fonction pour vérifier si on est sur le domaine admin
export function isAdminDomain() {
  // En développement, toujours true pour utiliser l'interface administrative
  if (!isProduction()) {
    return true;
  }
  
  const domain = getCurrentDomain();
  return domain.includes('padmar-performance.org') || domain.includes('localhost') || domain.includes('127.0.0.1');
}

// Configuration de l'API selon le domaine
export function getApiConfig() {
  if (isPortalDomain()) {
    return {
      baseURL: 'https://api.padmar-performance.org/api/',
      baseURLFile: 'https://api.padmar-performance.org/',
      title: 'Portail PADMAR-E',
      description: 'Portail public de suivi du PADMAR-E'
    };
  } else {
    return {
      baseURL: process.env.VUE_APP_BASE_URL || 'http://localhost:8000/api/',
      baseURLFile: process.env.VUE_APP_BASE_URL_FILE || 'http://localhost:8000/',
      title: 'Administration PADMAR-E',
      description: 'Interface d\'administration du PADMAR-E'
    };
  }
}

// Configuration des routes selon le domaine
export function getRouteConfig() {
  if (isPortalDomain()) {
    return {
      isPortal: true,
      allowedRoutes: ['public-portal', 'public-folder'],
      defaultRoute: 'public-portal',
      redirectUnauthorized: 'public-portal'
    };
  } else {
    return {
      isPortal: false,
      allowedRoutes: null, // Toutes les routes sont autorisées
      defaultRoute: 'default',
      redirectUnauthorized: 'login'
    };
  }
}

// Configuration de l'interface utilisateur selon le domaine
export function getUIConfig() {
  if (isPortalDomain()) {
    return {
      showAdminMenu: false,
      showPublicMenu: true,
      theme: 'public',
      layout: 'admin' // Utilise le même layout que l'admin
    };
  } else {
    return {
      showAdminMenu: true,
      showPublicMenu: false,
      theme: 'admin',
      layout: 'admin'
    };
  }
}

// Configuration des permissions selon le domaine
export function getPermissionConfig() {
  if (isPortalDomain()) {
    return {
      requireAuth: false,
      allowPublicAccess: true,
      restrictedFeatures: ['admin-panel', 'user-management', 'system-config', 'login']
    };
  } else {
    return {
      requireAuth: true,
      allowPublicAccess: false,
      restrictedFeatures: []
    };
  }
}

// Configuration complète
export function getDomainConfig() {
  return {
    domain: getCurrentDomain(),
    isProduction: isProduction(),
    isPortal: isPortalDomain(),
    isAdmin: isAdminDomain(),
    api: getApiConfig(),
    routes: getRouteConfig(),
    ui: getUIConfig(),
    permissions: getPermissionConfig()
  };
}

export default {
  getCurrentDomain,
  isProduction,
  isPortalDomain,
  isAdminDomain,
  getApiConfig,
  getRouteConfig,
  getUIConfig,
  getPermissionConfig,
  getDomainConfig
};
